import { render, staticRenderFns } from "./accounts-receivable-summary.vue?vue&type=template&id=27076b9b&scoped=true"
import script from "./accounts-receivable-summary.vue?vue&type=script&lang=js"
export * from "./accounts-receivable-summary.vue?vue&type=script&lang=js"
import style0 from "./accounts-receivable-summary.vue?vue&type=style&index=0&id=27076b9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27076b9b",
  null
  
)

export default component.exports